import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { TemplatePublishStatus, templatePublishStatusMessages } from './templatePublishStatus';
import '../document-wizard/document-badge/document-badge.scss';
import './TemplatePublishStatusBadge.scss';

interface TemplatePublishStatusBadgeProps {
  status: TemplatePublishStatus;
  className?: string;
}

export const TemplatePublishStatusBadge = ({ status, className }: TemplatePublishStatusBadgeProps) => (
  <small
    className={classNames(
      'document-badge',
      'template-publish-status-badge',
      `template-publish-status-badge--${status.replace(/_/g, '-')}`,
      className
    )}
    data-testid="template-publish-status"
    data-status={status}
  >
    <FormattedMessage {...templatePublishStatusMessages[status]} />
  </small>
);
